import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import IframeTemplate from '../../../components/templates/IframeTemplate'
import { COLORS } from '@btime/constants'
import { useUser } from './_load/UserLoader'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import Center from '../../../packages/kiti/components/helpers/Center'
import IconBlock from '../../../components/presentation/IconBlock'
import Loading from '../../../packages/kiti/components/helpers/Loading'
import { getLoggedUser } from '../../../utils/session/sessionStorage'

const PageContent = () => {
  const { t } = useTranslation('finance')
  const { canAccessPaymentModule } = getLoggedUser()
  const { superlogicaToken, email } = useUser()
  const [isLoading, setIsLoading] = useState(true)

  const superlogicaUrl = `${process.env.REACT_APP_SUPERLOGICA_PAYMENT_MODULE_URL}?email=${email}&token=${superlogicaToken}`

  if (!canAccessPaymentModule || !superlogicaToken) {
    return (
      <AbsoluteWithMenuSpacePageTemplate>
        <Center flex={1} minHeight="100vh">
          <IconBlock icon="BsSearch" title={t('noAccess')} subtitle={t('noPermission')} />
        </Center>
      </AbsoluteWithMenuSpacePageTemplate>
    )
  }

  return (
    <IframeTemplate bgColor={COLORS.white}>
      {isLoading && <Loading />}
      <iframe
        id="superlogica-iframe"
        src={superlogicaUrl}
        title={t('iframeTitle')}
        width={'100%'}
        height={'100%'}
        frameborder="0"
        onLoad={() => setIsLoading(false)}
      />
    </IframeTemplate>
  )
}

export default PageContent
